import React, {useEffect, useState} from 'react'
import moment from 'moment'
import TimelineEvent from "./TimelineEvent"
import "./Section.04.Timeline.css"
import {DndContext, DragOverlay, PointerSensor, TouchSensor, closestCenter, useSensor, useSensors} from '@dnd-kit/core'
import {SortableContext, arrayMove, verticalListSortingStrategy} from '@dnd-kit/sortable'

export default function TimelineSection(params) {

    const {rescue, values} = params
    const events = rescue.rescue.events ?? []
    
    useEffect(() => {
        if (!rescue.ready) return
        let evs = JSON.parse(JSON.stringify(events))
        let dirty = false
        
        if (!rescue.rescue.id && !rescue.rescue.events?.length) {
            evs = initEvents()
            dirty = true
        }
    
        // Do events have ids? 
        for (let i=0; i<evs.length; i++) {
            const event = evs[i]
            if (!('id' in event)) {                
                event['id'] = new Date(event.time).getTime() + i
                dirty = true
            }
        }
        if (dirty) {            
            rescue.setField("events", evs)
        }
    }, [rescue.ready])
    
    
    function initEvents() {
		const now = new Date()
		const minute = 60001
		const timeReceive = new Date(now.getTime() - 8 * minute)
		const timeArrival = new Date(now.getTime() - 6 * minute)
		const timeStartAid = new Date(now.getTime() - 5 * minute)
		const timeEndAid = new Date(now.getTime() - 1 * minute)
		const timeStartTransport = new Date(now.getTime() + 2 * minute)
		const timeEndAction = new Date(now.getTime() + 6 * minute)
		
		return [{
			'time': moment(timeReceive).toISOString(true),
			'event': 'Prijem poziva'
		},
		{
			'time': moment(timeArrival).toISOString(true),
			'event': 'Dolazak spasilaca'
		},
		{
			'time': moment(timeStartAid).toISOString(true),
			'event': 'Početak pružanja prve pomoći'
		},
		{
			'time': moment(timeEndAid).toISOString(true),
			'event': 'Kraj pružanja prve pomoći'
		},
		{
			'time': moment(timeStartTransport).toISOString(true),
			'event': 'Početak transporta'
		},
		{
			'time': moment(timeEndAction).toISOString(true),
			'event': 'Završetak akcije'
		}]
	}
    
    const setEvent = (index, event) => {
        const evs = JSON.parse(JSON.stringify(events))
        evs[index] = event
        evs.sort(function(a, b) {
  			const keyA = new Date(a.time)
  			const keyB = new Date(b.time)
  			return keyA - keyB
  		})
        rescue.setField("events", evs)
    }
    
    const byTime = (a, b) => {
        if (a.time < b.time) return -1
        if (a.time > b.time) return 1
        return 0
    }
    
    const incTime = (index, inc) => {
        const evs = JSON.parse(JSON.stringify(events))
        inc = inc * 60000
        if (index > 0) {
            const diff = new Date(evs[index-1].time) - new Date(evs[index].time)
            if (inc < diff) inc = diff
        }
        
        while (index < evs.length) {
            let time = new Date(evs[index].time)
    		time = new Date(time.getTime() + inc)
    		evs[index].time = moment(time).toISOString(true)
    		index++
        }
        rescue.setField("events", evs.sort(byTime))
    }
    
    const getDate = () => {
        const firstTime = events.find(ev => ev.time)?.time
        if (!firstTime) return moment().toISOString(true).split('T')[0]
        return firstTime.split('T')[0]
    }

    const setDate = (e) => {
        const firstTime = events.find(ev => ev.time)?.time
        if (!firstTime) return
        const evs = JSON.parse(JSON.stringify(events))
        const yyyymmdd = e.target.value
		let oldStart = new Date(firstTime.split('T')[0])
		let newStart = new Date(yyyymmdd)
		let diff = newStart.getTime() - oldStart.getTime()
		for (var i in evs) {
			let oldTimestamp = new Date(evs[i].time).getTime()
			let newTime = new Date(oldTimestamp + diff)
			if (isNaN(newTime)) newTime = newStart
			evs[i].time = moment(newTime).toISOString(true)
		}
		rescue.setField("events", evs)
    }
    
    const addEvent = (e) => {
        const text = e.target.value
        const evs = JSON.parse(JSON.stringify(events))
        if (evs.length > 0) {
            const lastEvent = evs[evs.length-1]
            const event = {
                event: text,
                time: lastEvent.time,
                id: lastEvent.id + 1
            }
            evs.push(event)
        }
        else {
            const time = new Date()
            const event = {
                event: text,
                time: moment(time).toISOString(true),
                id: time.getTime()
            }
            evs.push(event)
        }
        rescue.setField("events", evs)
    }


    const removeEvent = (index) => {
        const evs = JSON.parse(JSON.stringify(events))
        evs.splice(index, 1)
        rescue.setField("events", evs)
    }

    const [openPickerIndex, setOpenPickerIndex] = useState(null)
    const [activeId, setActiveId] = useState(null)
    const activeEvent = activeId ? events.find(e => e.id === activeId) : null

    const insertEvent = (index, text) => {
        if (index === 0) return
        const evs = JSON.parse(JSON.stringify(events))
        const prevTime = moment(evs[index - 1].time).valueOf()
        const nextTime = moment(evs[index].time).valueOf()
        const midTime = prevTime === nextTime ? prevTime : Math.round((prevTime + nextTime) / 2)
        const newEvent = {
            event: text,
            time: moment(midTime).toISOString(true),
            id: Math.floor(Date.now() + Math.random() * 1000)
        }
        evs.splice(index, 0, newEvent)
        setOpenPickerIndex(null)
        rescue.setField("events", evs)
    }

    const sensors = useSensors(
        useSensor(PointerSensor, {activationConstraint: {distance: 8}}),
        useSensor(TouchSensor, {activationConstraint: {delay: 250, tolerance: 5}})
    )

    const onDragStart = ({active}) => setActiveId(active.id)

    const onDragEnd = ({active, over}) => {
        setActiveId(null)
        if (!over || active.id === over.id) return

        const evs = JSON.parse(JSON.stringify(events))
        const oldIndex = evs.findIndex(e => e.id === active.id)
        const newIndex = evs.findIndex(e => e.id === over.id)

        const reordered = arrayMove(evs, oldIndex, newIndex)

        // Recalculate time for the moved event based on its new neighbors
        const prev = reordered[newIndex - 1]
        const next = reordered[newIndex + 1]

        if (prev && next) {
            const midpoint = Math.round((moment(prev.time).valueOf() + moment(next.time).valueOf()) / 2)
            reordered[newIndex].time = moment(midpoint).toISOString(true)
        } else if (!prev && next) {
            // Dropped at start: 1 minute before next
            reordered[newIndex].time = moment(moment(next.time).valueOf() - 60000).toISOString(true)
        } else if (prev && !next) {
            // Dropped at end: 1 minute after prev
            reordered[newIndex].time = moment(moment(prev.time).valueOf() + 60000).toISOString(true)
        }

        rescue.setField("events", reordered.sort(byTime))
    }

    return <li className="accordion" id="accordion-timeline">
        <input type="checkbox" className="accordion" name="accordion" id="acc-timeline"/>
        <label className="accordion" htmlFor="acc-timeline">Tok događaja</label>
        <section className="accordion">
            <div id="timeline-header">
                <div>
        		    <div>Datum početka akcije</div>
        			<input type="date" value={getDate()} className="datetime" required onChange={setDate} readOnly={rescue.isReadOnly}/>
    		    </div>
      		    <div>
                  	<div>Vreme kreiranja povredne liste</div>
                    <div>{moment(rescue.rescue?.created).format('LLLL')}</div>
                </div>
            </div>
            	  
            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={onDragStart} onDragEnd={onDragEnd}>
                <SortableContext items={events.map(e => e.id)} strategy={verticalListSortingStrategy}>
                    <div id="events">
                        {events.map((event, index) => <TimelineEvent
                            key={event.id ?? index}
                            rescue={rescue}
                            events={events}
                            index={index}
                            setEvent={setEvent}
                            incTime={incTime}
                            removeEvent={removeEvent}
                            insertEvent={insertEvent}
                            values={values}
                            openPickerIndex={openPickerIndex}
                            setOpenPickerIndex={setOpenPickerIndex}
                        />)}
                    </div>
                </SortableContext>
                <DragOverlay>
                    {activeEvent && <div className="one-event drag-overlay">
                        <div className="event-header">
                            <span className="drag-handle"><i className="fas fa-grip-vertical"/></span>
                            <span className="event">{activeEvent.event}</span>
                        </div>
                    </div>}
                </DragOverlay>
            </DndContext>
              
            {!rescue.isReadOnly && <div className="subsection">
                <h5>Dodaj događaj</h5>
                <div id="event-buttons">
                    {values?.events?.map(event => <button key={event.id} className="btn btn-sm btn-light" value={event.name} onClick={addEvent}>{event.name}</button>)}
                </div>
            </div>}
        </section>
    </li>
    
}
